import { PointCloudManager } from './PointCloudManager'
import { PointCloud } from './PointCloud'
import { Swath } from './Swath'

import * as hdf5 from 'jsfive/dist/esm/index.mjs';
import {cellToLatLng} from "h3-js";

export class SwathManager extends PointCloudManager {

  constructor({world, datafilePath, dbFile,
    pointSize=1.0,
    bbox = undefined,
    shader = PointCloud.getShader({}),
    colormap = 'jet',
    swathHeight = 10.0
  }){

    super(world);

    this.datafilePath = datafilePath;
    this.pointSize = pointSize;

    this.swathHeight = swathHeight;

    this.shader = shader;
    this.colormap = colormap;

    this.bbox = bbox;

    this.loadDatabase(dbFile);

  }

  loadDatabase(dbFile, callback=function(){}){
    fetch(dbFile).then(r => r.json()).then(j => {
        this.setDatabase(j);
    }).then(callback);
  }

  setDatabase(database){
    this.database = database;
  }

  static fetchFromH3HDF5({cloud, filename, alphaFunction, world, pointSize, clouds,
    callback=undefined, bbox=undefined, shader, colormap, swathHeight}){

    fetch(filename).then(function (response) {
      return response.arrayBuffer();
    }).then(function(buffer) {

      if(cloud.delete){
        console.log('Deleted: ' + cloud.toString());
        delete clouds[filename];
        return;
      }

      let f = new hdf5.File(buffer, filename);

      let h3_msw = f.get('h3_msw').value;
      let h3_lsw = f.get('h3_lsw').value;
      let vals = f.get('ta').value;

      let ts = [];
      let lats = [];
      let lngs = [];

      for(let i = 0; i < vals.length; i++){
        let idx = [h3_lsw[i], h3_msw[i]];
        const [ lat, lng ] = cellToLatLng(idx);
        lats.push(lat);
        lngs.push(lng);
        ts.push(0);
        vals[i] = vals[i] / 255;
      }

      cloud.loadSwath({world, ts, lats, lngs, vals, alphaFunction, pointSize, bbox, shader, colormap, swathHeight});
      cloud.add(world.scene());
      cloud.geometry.drawRange.count = 0;

      if(callback){
        callback(cloud);
      }

    });
  }

  static fetchFromHDF5({cloud, filename, alphaFunction=SwathManager.defaultAlphaFunction, world, pointSize=1.0, clouds,
    callback=undefined, bbox=undefined, shader, colormap, swathHeight}){

    fetch(filename).then(function (response) {
      return response.arrayBuffer();
    }).then(function(buffer) {

      if(cloud.delete){
        console.log('Deleted: ' + cloud.toString());
        delete clouds[filename];
        return;
      }

      let f = new hdf5.File(buffer, filename);
      cloud.loadSwath({
        world,
        ts: f.get('unix_timestamps').value,
        lats:  f.get('latitude').value,
        lngs: f.get('longitude').value,
        vals: f.get('ta').value,
        alphaFunction, pointSize, bbox,
        shader, colormap, swathHeight
      });
      cloud.add(world.scene());

      if(callback){
        callback(cloud);
      }

    });

  }

  static defaultAlphaFunction(v){
    return 1;
  }

  load(metadata, alphaFunction=SwathManager.defaultAlphaFunction, callback=undefined){

    let filename = this.datafilePath + metadata.filename;

    // Dont load swath if it already exists
    if(metadata.filename in this.clouds){
      return false;
    }

    let cloud = new Swath(metadata);

    console.log(metadata.filename);
    this.clouds[metadata.filename] = cloud;
    SwathManager.fetchFromHDF5({cloud, filename, alphaFunction, world: this.world,
      pointSize: this.pointSize, clouds: this.clouds, callback, bbox: this.bbox,
      shader: this.shader, colormap: this.colormap, swathHeight: this.swathHeight});

    return true;

  }

}